// language=GraphQL
export const ALL_HEADING_BLOCKS_QUERY = `query Query {
  headingBlocks: cmsHeadingBlocks {
    id
    importance
    heading
    addon
    decoration
  }
}`

// language=GraphQL
export const SINGLE_HEADING_BLOCK_QUERY = `query Query($id: ID!) {
  headingBlock: cmsHeadingBlock(id: $id) {
    id
    importance
    heading
    addon
    decoration
  }
}`

// language=GraphQL
export const CREATE_HEADING_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsHeadingBlockInput) {
    headingBlock: createCmsHeadingBlock(input: $input) {
      id
      importance
      heading
      addon
      decoration
    }
  }`

// language=GraphQL
export const UPDATE_HEADING_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsHeadingBlockInput) {
    headingBlock: updateCmsHeadingBlock(input: $input) {
      id
      importance
      heading
      addon
      decoration
    }
  }`

// language=GraphQL
export const DELETE_HEADING_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsHeadingBlockInput) {
    deleteCmsHeadingBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_HEADING_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsHeadingBlockInput) {
    forceDeleteCmsHeadingBlock(input: $input) {
      success
    }
  }`
